<template>
  <hm-content title="">
    <div class="flex flex-end item-center">
      <el-button size="small" type="primary" @click="search"
        >查询</el-button
      >
    </div>
    <div class="table mt20">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
        v-if="resetForm"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="reportName"
          label="人群名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="resultRowsNum"
          label="最近覆盖人数"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="schedulingTime"
          label="最后一次执行时间"
        >
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          label="过期时间"
          prop="name"
        >
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="showUpdate(scope.row)"
                >更新</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="queryReportsList(scope.row)"
                >查看人群记录</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div> -->
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="人群记录"
      width="80%"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="table">
        <el-table
          stripe
          :data="reportsList"
          style="width: 100%"
          id="table"
          size="small"
          border
          :max-height="400"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="
              (index) => index + (currentPageReports - 1) * pageSizeReports + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="reportResultName"
            label="自定义名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="reportName"
            label="人群包名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="resultRowsNum"
            label="人群人数"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="schedulingTime"
            label="执行时间"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="操作人"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button size="small" type="text" @click="save(scope.row)"
                  >下载</el-button
                >
                <el-button size="small" type="text" @click="add">分配导购联系</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="hm-pagination">
          <el-pagination
            background
            :total="totalReports"
            @current-change="pagingReports"
            @size-change="handleSizeChangeReports"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPageReports"
          ></el-pagination>
        </div> -->
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="更新人群包"
      width="600px"
      :visible.sync="dialogVisibleReportResultName"
      :before-close="handleClose2"
    >
      <div>
        <div class="mb20">将按以下规则执行运算：</div>
        <div class="mb20">
          {{currentRows.remark}}
        </div>
        <div class="mb20">人群包命名</div>
        <el-input
          clearable
          style="width: 300px"
          v-model.trim="reportResultName"
          placeholder="请输入人群包命名"
          size="small"
          class="ipt"
        ></el-input>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button type="primary" size="small" @click="updateDetail"
          >执行更新</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="更新人群包"
      width="600px"
      :visible.sync="dialogVisibleReportMsg"
      :before-close="handleClose2"
    >
      <div class="flex flex-center">
        <div class="mt20 mb20">请耐心等待一段时间，执行成功后状态将会更新</div>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button type="primary" size="small" @click="closeDialogVisibleReportMsg"
          >我知道了</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      isOutputing: false,
      list: [],
      reportConfigIdList: [],
      reportResultName: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      resetForm: true,
      rows: {},
      reportsList: [],
      currentPageReports: 1,
      pageSizeReports: 10,
      totalReports: 0,
      dialogVisible: false,
      reportCode: "",
      dialogVisibleReportResultName: false,
      dialogVisibleReportMsg: false,
      currentRows: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then((res) => {
            const list = res;
            list.forEach((v) => {
              v.startDates = v.startDate + "至" + v.endDate;
            });
            const tHeader = this.$refs.table.columns
              .map((o) => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter((o) => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map((o) => o._props.prop)
                .filter((o) => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "活动列表" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // paging(page) {
    //   this.currentPage = page;
    //   this.queryList();
    // },
    // handleSizeChange(size) {
    //   this.currentPage = 1;
    //   this.pageSize = size;
    //   this.queryList();
    // },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      let params = {};
      const { result } = await this.$store.dispatch(
        "queryPeoplePackageCalcResult",
        params
      );
      this.list = result;
    },
    showUpdate(row) {
      this.currentRows = row;
      this.reportResultName = "";
      this.dialogVisibleReportResultName = true;
    },
    async updateDetail() {
      if (this.currentRows && this.currentRows.reportConfigId) {
        this.reportConfigIdList = [];
        this.reportConfigIdList.push(this.currentRows.reportConfigId);
      }
      if (!this.reportConfigIdList.length) {
        this.$message({
          message: "更新失败,无ID",
          type: "warning",
        });
        return;
      }
      if (!this.reportResultName) {
        this.$message({
          message: "请输入人群包命名",
          type: "warning",
        });
        return;
      }
      let params = {
        reportConfigIdList: this.reportConfigIdList,
        reportResultName: this.reportResultName,
      };
      const { code } = await this.$store.dispatch(
        "execPeoplePackageCalc",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.dialogVisibleReportResultName = false;
        this.dialogVisibleReportMsg = true;
        this.queryList();
      }
    },
    save(row) {
      this.rows = row;
      axios({
        method: "post",
        url:
          this.$serverAdress +
          `/sys/common/download?filePath=${row.responseResultPath}`,
        responseType: "arraybuffer",
      }).then((res) => {
        this.download(res.data);
      });
    },
    download(data) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", this.rows.fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // pagingReports(page) {
    //   this.currentPageReports = page;
    //   this.queryReportsList();
    // },
    // handleSizeChangeReports(size) {
    //   this.currentPageReports = 1;
    //   this.pageSizeReports = size;
    //   this.queryReportsList();
    // },
    async queryReportsList(row) {
      this.reportCode = row.reportCode;
      let params = {
        reportCode: this.reportCode,
      };
      const { result } = await this.$store.dispatch(
        "queryPeoplePackageDetailResult",
        params
      );
      this.reportsList = result;
      this.dialogVisible = true;
    },
    handleClose2() {
      this.dialogVisibleReportResultName = false;
    },
    closeDialogVisibleReportMsg(){
      this.dialogVisibleReportMsg = false;
      this.queryList();
    },
    add() {
      this.$router.push({
        name: "AddShoppersTask",
        query: {
          model: 'peoplePackage',
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
